/* eslint-disable global-require */
const dynamicState = {};

// `require` in every file except index.js from the current directory, then
// add their default export to module.exports based on their filename.
// eg dynamicMiddlewares["dynamicMiddleware"] = require("./dynamicMiddleware.js");
const req = require.context('.', false, /\.initialState\.js$/);
req.keys().forEach(fileName => {
  const exportName = fileName.replace('./', '').replace('.initialState.js', '');
  dynamicState[exportName] = req(fileName).default;
});

export { dynamicState };
